export default __webpack_public_path__ + "media/images/ui-icons_cc0000_256x240-2077b5eab79cbbc34dc270e93bf36bbc.png";